import {SmartComponent} from "smart-component-js";

class OtherCategoryInfo extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.init();
    }

    init() {
        const buttons = this.element.querySelectorAll(".other-category-info__expandable"); // Usa this.element per limitare la ricerca

        buttons.forEach(button => {
            button.addEventListener("click", () => {
                const content = button.nextElementSibling;
                const iconMinus = button.querySelector(".other-category-info__expandable-icon.minus");
                const iconPlus = button.querySelector(".other-category-info__expandable-icon.plus");

                if (content.classList.contains("visible")) {
                    content.classList.remove("visible");
                    iconMinus.classList.add("hidden");
                    iconPlus.classList.remove("hidden");

                } else {
                    content.classList.add("visible");
                    iconPlus.classList.add("hidden");
                    iconMinus.classList.remove("hidden");
                }
            });
        });
    }
}

export default OtherCategoryInfo;